import React, { useState, useEffect } from "react";
import { Row, Col, Table } from "react-bootstrap";
import { Content, Sidebar, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import useWrapper from "../../../hooks/useWrapper";
import api from "../../../services/api";
import TableResponsive from "../../../components/TableResponsive";
import { formatDate, formatReal } from "../../../util/functions";
import ModalProductTrainee from "../../../components/Modal/modal-product-trainee";
import Button from "../../../components/Button";

export default function Produtos() {
  const { config, me, loadMe } = useWrapper();
  const [customPaymentSlip, setcustomPaymentSlip] = useState();

  useEffect(() => {
    if (me?.paymentSlip) {
      const custom_payment_slip = me?.paymentSlip?.filter(__payment_slip => !!__payment_slip.custom_payment_id) || [];
      setcustomPaymentSlip(custom_payment_slip);
    }
  }, [JSON.stringify(me?.paymentSlip)]);

  const [productModal, setproductModal] = useState({
    show: false,
    product_pre_load: null,
  });
  const [customPayment, setcustomPayment] = useState();
  useEffect(() => {
    if (!!customPaymentSlip) {
      (async () => {
        const { data: custom_payment } = await api.get(`trainee/custom-payment?type_method=produto`, config);

        console.log("custom_payment", custom_payment);
        let _custom_payment = custom_payment.map(__custom_payment => ({
          ...__custom_payment,
          has_amount: customPaymentSlip
            .filter(__custom_payment_slip => __custom_payment_slip.custom_payment_id === __custom_payment.id)
            .reduce((__acc, __current) => __acc + Number(__current.aditional_information), 0),
        }));
        setcustomPayment(_custom_payment);
      })();
    }
  }, [customPaymentSlip]);

  return (
    <>
      <ModalProductTrainee
        show={productModal?.show}
        closeModal={() => {
          setproductModal({ show: false, id: null });
        }}
        productPreLoad={productModal.product_pre_load}
        has_amount={productModal.has_amount}
      />
      <Main className={style.mainUser}>
        <Content noBG="true">
          <Row>
            <Col md={12} lg={2}>
              <MenuTrainee />
            </Col>
            <Col>
              <SubContent>
                <h2 className="form-title mb-4">Produtos Disponíveis</h2>
                <TableResponsive
                  table={{
                    head: [
                      { data: "Produto" },
                      { data: "Disponibilidade" },
                      { data: "Quantidade" },
                      { data: "Valor" },
                      { data: "" },
                    ],
                    body:
                      customPayment?.map(__payment => ({
                        onClick: () => {
                          setproductModal({
                            show: true,
                            product_pre_load: __payment,
                            has_amount: __payment.has_amount,
                          });
                        },
                        data: [
                          { element: __payment.name },
                          {
                            element: `${formatDate(__payment.date_start, 2)} ~ ${formatDate(__payment.date_end, 2)}`,
                          },
                          {
                            element: `${__payment.has_amount}/${__payment.quantity}`,
                          },
                          {
                            element: formatReal((__payment.value || 0) + (__payment.contribution_value || 0)),
                          },
                          {
                            element:
                              __payment.has_amount < __payment.quantity ? (
                                <div className="text-end">
                                  <Button size="sm">Comprar</Button>
                                </div>
                              ) : (
                                ""
                              ),
                          },
                        ],
                      })) || [],
                  }}
                />
              </SubContent>
            </Col>
          </Row>
        </Content>
      </Main>
    </>
  );
}
